module.exports = __webpack_public_path__ + "img/transfer4.b31382aa.jpeg";